import React, { Suspense, lazy } from 'react';
import { Router, Redirect, Switch, Route } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import PrivateAdminRoute from '../components/main/Admin/PrivateAdminRoute';

const history = createBrowserHistory();

const lowercaseAdminPath = (pathname) => pathname.replace(/^\/admin/i, '/admin');

const normalizeAdminLocation = (location) => {
    const nextPath = lowercaseAdminPath(location.pathname);
    if (nextPath !== location.pathname) {
        history.replace(nextPath + location.search + location.hash);
    }
};

normalizeAdminLocation(history.location);
history.listen(normalizeAdminLocation);

const HomePage = lazy(() => import('../components/main/HomePage'));
const CarInfoPage = lazy(() => import('../components/main/CarInfoPage'));
const VehiclesPage = lazy(() => import('../components/main/VehiclesPage'));
const AdminLogin = lazy(() => import('../components/main/Admin/AdminLogin'));
const AdminCarsList = lazy(() => import('../components/main/Admin/AdminCarsList'));

const Routes = () => {
    return (
        <Router history={history}>
            <Suspense fallback={<div>Loading...</div>}>
                <Switch>
                    <Route exact path="/" component={HomePage} />
                    <Route exact path="/car/:carId" component={CarInfoPage} />
                    <Route exact path="/vehicles" component={VehiclesPage} />

                    <Route exact path="/admin/login" component={AdminLogin} />
                    <PrivateAdminRoute exact path="/admin" component={AdminCarsList} />
                    <PrivateAdminRoute exact path="/admin/" component={AdminCarsList} />
                    <Route exact path="/admin/cars" render={() => <Redirect to="/admin" />} />
                    <Route exact path="/admin/add-car" render={() => <Redirect to="/admin" />} />
                    <Route exact path="/admin/edit/:id" render={() => <Redirect to="/admin" />} />

                    <Route render={() => <h1>404 Not Found</h1>} />
                </Switch>
            </Suspense>
        </Router>
    );
};

export default Routes;
